import React from "react";
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../images/roeicarE.png"
import Context from "../../storage/context";

const NavAdmin = () => {
    const ctx = useContext(Context);
    const [menuOpen, setMenuOpen] = useState(false);

    let navigate = useNavigate();

    const disconnect = () => {
        localStorage.removeItem("token");
        navigate("/login");

    }


    const onClick = (e) => {
        ctx.setTabSelectedAdmin(e.target.innerText)
    }
    return (
        <nav className="nav">
            <div className="nav-inner">
                <div className="logo-wrap">
                    <img src={logo} className="logo-img" alt="Roei Car" onClick={() => navigate("/admin", { replace: true })} loading="lazy" />
                </div>

                <nav className="nav-links">
                    <a className={ctx.tagSelectedAdmin === "עריכת רכבים" ? "nav-link nav-selected" : "nav-link"} onClick={onClick}>עריכת רכבים</a>
                    <a className={ctx.tagSelectedAdmin === "עריכת באנר המלצות" ? "nav-link nav-selected" : "nav-link"} onClick={onClick}>עריכת באנר המלצות</a>
                    <a className={ctx.tagSelectedAdmin === "ניהול משתמשים" ? "nav-link nav-selected" : "nav-link"} onClick={onClick}>ניהול משתמשים</a>
                    <a className={ctx.tagSelectedAdmin === "ניהול המלצות" ? "nav-link nav-selected" : "nav-link"} onClick={onClick}>ניהול המלצות</a>
                    <a className="nav-link" onClick={disconnect}>התנתק</a>
                </nav>

                <div className="nav-right">
                    <span className="nav-phone">
                        <svg viewBox="0 0 24 24" fill="none" strokeWidth="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8 19.79 19.79 0 01.07 1.18 2 2 0 012.03 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z" /></svg>
                        0507667702
                    </span>
                    <button
                        className="hamburger"
                        onClick={() => setMenuOpen(o => !o)}
                        aria-label="תפריט"
                        style={{ display: "none" }}
                        ref={el => { if (el) el.style.display = "flex"; }}
                    >
                        <span className="ham-line" style={{ transform: menuOpen ? "rotate(45deg) translate(5px,5px)" : "none" }} />
                        <span className="ham-line" style={{ opacity: menuOpen ? 0 : 1 }} />
                        <span className="ham-line" style={{ transform: menuOpen ? "rotate(-45deg) translate(5px,-5px)" : "none" }} />
                    </button>
                </div>
            </div>

            <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
                <a onClick={onClick}>עריכת רכבים</a>
                <a onClick={onClick} >עריכת באנר המלצות</a>
                <a onClick={onClick} >ניהול משתמשים</a>
                <a onClick={onClick} >ניהול המלצות</a>
                <a onClick={disconnect} >התנתק</a>
            </div>
        </nav>
    );
};

export default NavAdmin;